var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _circle, _circle2, _path11, _path12, _path13, _path14, _mask, _path15, _path16, _path17, _path18, _path19, _path20, _use, _mask2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _use2, _mask3, _path37, _path38, _path39, _use3, _use4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvilMinion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 673,
    viewBox: "0 0 479 673",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1254_4068)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.734 138.025C318.155 151.109 307.806 160.299 299.377 180.034C299.178 180.5 298.652 180.753 298.164 180.613C268.46 172.122 250.283 170.351 216.653 171.963C216.295 171.98 215.944 171.798 215.751 171.496C198.551 144.513 197.431 129.145 197.969 104.143C197.991 103.093 199.418 102.781 199.885 103.722C205.924 115.891 210.609 122.307 222.305 124.11C222.819 124.189 223.307 123.84 223.415 123.332C229.481 94.8246 228.141 77.4037 219.534 49.9272C219.183 48.8077 220.685 48.0924 221.297 49.0927C233.788 69.4841 238.986 85.4292 240.959 112.079C241.048 113.285 243.057 113.397 243.293 112.211C246.691 95.0876 250.901 86.6382 257.865 77.0417C258.501 76.1662 259.86 76.81 259.62 77.8649C254.229 101.604 254.711 114.457 262.471 131.932C262.758 132.579 263.62 132.716 264.105 132.2C286.194 108.698 294.614 92.5122 300.757 62.9187C300.982 61.8359 302.571 61.8393 302.776 62.926C306.327 81.7389 308.52 93.9437 303.95 112.305C303.744 113.13 304.587 113.834 305.351 113.461C325.632 103.558 330.797 93.8677 342.915 78.7573C329.431 100.812 322.274 113.632 319.071 140.475C318.983 141.212 319.704 141.789 320.401 141.533L334.789 136.264C335.876 135.866 336.662 137.334 335.734 138.025Z",
    fill: "#67437E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.748 128.684C294.975 152.82 298.886 168.186 293.942 192.457C293.841 192.954 294.131 193.461 294.612 193.623C327.973 204.864 346.129 214.935 376.623 238.199C376.907 238.416 377.301 238.465 377.63 238.326C411.405 224.075 422.294 210.331 438.097 186.287C438.674 185.409 437.675 184.343 436.758 184.855C422.93 192.568 414.339 195.687 402.028 189.685C401.561 189.457 401.356 188.892 401.555 188.412C414.424 157.423 427.047 141.976 453.426 121.476C454.352 120.756 453.518 119.314 452.444 119.785C426.648 131.1 411.28 142.833 391.585 167.533C390.831 168.478 389.14 167.452 389.627 166.345C398.108 147.052 399.617 136.216 399.22 122.123C399.19 121.042 397.702 120.806 397.302 121.811C386.897 147.991 378.141 159.789 359.349 171.251C358.745 171.62 357.956 171.243 357.849 170.543C352.267 133.931 354.891 113.308 368.505 81.2242C368.937 80.2062 367.632 79.3043 366.846 80.0825C351.022 95.7517 340.942 105.771 333.276 126.303C332.979 127.1 331.883 127.198 331.464 126.458C318.727 103.953 320.163 91.5455 318.569 69.5112C316.951 98.9109 315.373 115.53 300.96 142.822C300.613 143.478 299.691 143.545 299.262 142.939L288.519 127.766C287.851 126.822 286.374 127.589 286.748 128.684Z",
    fill: "#67437E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.432 527.632L212.526 516.108L248.646 519.628L245.832 535.861C251.944 545.532 254.049 562.777 248.18 567.379C242.312 571.981 215.995 566.46 209.566 561.645C203.137 556.83 201.528 549.585 202.683 541.264C203.5 535.38 209.432 527.632 209.432 527.632Z",
    fill: "#232631"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.277 504.004L126.086 483.852L160.144 493.374C160.144 493.374 161.086 498.755 161.994 502.13C163.835 508.973 169.457 515.798 168.614 519.025C167.772 522.252 157.556 524.411 149.109 527.721C140.662 531.031 132.016 541.472 118.855 543.263C108.45 544.679 94.2717 542.361 92.1955 539.75C90.1193 537.14 90.8788 526.308 91.7212 523.081C92.5636 519.854 108.492 507.047 124.277 504.004Z",
    fill: "#232631"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.564 165.682C142.136 191.493 103.475 392.702 103.475 392.702L101.502 423.06L132.381 457.605L283.145 505.805L304.413 495.991L311.915 479.554C298.883 459.066 408.743 303.221 369.58 224.753C349.566 184.654 267.301 150.968 218.564 165.682Z",
    fill: "#825CCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1254_4068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 162,
    width: 278,
    height: 344
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.564 165.682C142.136 191.493 103.475 392.702 103.475 392.702L101.502 423.06L132.381 457.605L283.144 505.805L308.735 497.151L314.994 468.018C301.962 447.531 408.743 303.221 369.58 224.753C349.566 184.654 267.301 150.968 218.564 165.682Z",
    fill: "#FDDB44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1254_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.173 207.739C328.373 180.262 290.673 167.739 290.673 167.739L335.082 145.927L387.558 249.591L352.282 426.991L304.413 495.991L242.671 530.378L95.9488 478.63L76.3533 419.315L125.848 298.242C125.848 298.242 125.983 332.255 145.377 340.551C164.771 348.846 242.627 386.738 260.514 377.641C278.4 368.544 325.973 235.216 327.173 207.739Z",
    fill: "#3F215D"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.138 105.809C246.434 128.67 252.309 143.397 250.562 168.105C250.527 168.611 250.88 169.076 251.379 169.174C285.918 175.982 305.228 183.608 338.488 202.709C338.799 202.887 339.195 202.886 339.504 202.705C371.139 184.184 380.148 169.141 392.692 143.246C393.149 142.301 392.021 141.374 391.178 142C378.47 151.446 370.357 155.655 357.37 151.304C356.878 151.139 356.601 150.605 356.736 150.104C365.467 117.705 375.975 100.748 399.464 76.9922C400.289 76.1581 399.275 74.8363 398.271 75.4431C374.165 90.0158 360.453 103.647 344.136 130.698C343.512 131.733 341.702 130.935 342.04 129.775C347.941 109.543 348.029 98.6028 345.803 84.681C345.632 83.6129 344.126 83.5724 343.861 84.621C336.947 111.931 329.8 124.768 312.658 138.576C312.106 139.02 311.275 138.748 311.078 138.068C300.784 102.493 300.704 81.7033 310.031 48.1224C310.327 47.0569 308.916 46.3324 308.238 47.2061C294.586 64.7995 285.893 76.0445 280.962 97.3991C280.771 98.2279 279.697 98.4673 279.185 97.7879C263.631 77.1295 263.442 64.641 258.996 43.001C261.215 72.3614 261.81 89.0442 251.068 117.978C250.809 118.675 249.904 118.861 249.4 118.316L236.775 104.668C235.99 103.819 234.625 104.771 235.138 105.809Z",
    fill: "#A75DD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.496 110.5C283.015 135.037 283.784 148.754 268.996 173C281.904 176.669 288.147 178.652 296.996 182C306.798 170.835 306.385 162.879 304.996 148.5C300.809 157.273 297.919 161.193 289.996 163C292.697 141.473 287.261 130.297 276.496 110.5Z",
    fill: "#6B2994"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.22 320.93C119.628 317.839 123.035 314.501 123.035 314.501L121.101 321.704C120.327 324.585 133.513 349.774 136.674 355.256C137.069 355.942 137.674 357.256 141.174 361.756C140.134 401.063 212.674 415.256 267.674 405.756C269.674 405.422 273.617 404.679 274.174 404.756C286.085 406.409 337.143 402.875 337.143 402.875L340.904 394.618C340.904 394.618 343.054 398.696 343.679 401.541C345.427 409.506 340.091 420.655 338.264 421.708L330.954 425.923C330.954 425.923 279.162 429.006 272.133 437.929C265.104 446.853 259.969 471.729 263.024 483.36C266.079 494.991 306.808 492.027 304.413 496.017C302.018 500.007 275.5 521.833 255.076 524.469C227.879 527.977 201.929 520.784 169.977 507.798C140.455 495.799 124.373 487.832 112.955 478.589C101.537 469.345 98.4825 457.715 98.4153 440.708C98.3482 423.702 118.314 378.098 118.314 378.098C118.314 378.098 109.255 358.809 110.204 345.033C110.844 335.735 114.458 329.187 118.22 320.93Z",
    fill: "#3E344F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.19 373.429C140.909 368.721 135.747 353.435 135.747 353.435C170.849 404.709 201.904 414.833 273.744 404.849C274.467 404.745 274.88 404.69 274.88 404.69C274.5 404.744 274.122 404.797 273.744 404.849C269.54 405.454 254.856 407.715 250.178 410.413C244.696 413.574 227.078 490.697 221.209 495.299C215.34 499.901 197.387 491.991 173.284 483.976C152.478 477.056 119.704 464.957 115.595 451.499C111.487 438.04 141.47 378.137 141.19 373.429Z",
    fill: "url(#paint0_linear_1254_4068)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.974,
    cy: 261.437,
    rx: 42.2631,
    ry: 45.3023,
    transform: "rotate(15.0289 241.974 261.437)",
    fill: "#CBBED8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.683,
    cy: 267.184,
    rx: 36.2255,
    ry: 37.7349,
    transform: "rotate(15.0289 246.683 267.184)",
    fill: "#FDFEF9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 244.499,
    cy: 269.5,
    r: 19.9985,
    transform: "rotate(15.0289 244.499 269.5)",
    fill: "#0D071D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.264,
    cy: 258.546,
    r: 4.99963,
    transform: "rotate(15.0289 242.264 258.546)",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M242.604 277.838C238.494 276.44 236.031 270.821 234.746 266.72C234.029 264.429 231.508 263.049 229.28 263.944C227.523 264.65 226.568 266.541 227.19 268.33C228.996 273.526 233.338 283.518 240.536 285.541C248.432 287.761 257.515 279.797 260.316 277.09C260.864 276.56 261.031 275.769 260.788 275.048L260.373 273.816C259.892 272.389 258.072 271.906 256.878 272.823C253.478 275.432 247.248 279.418 242.604 277.838Z",
    fill: "url(#paint1_linear_1254_4068)",
    strokeWidth: 2.07205,
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.176 321.26C234.673 340.752 175.174 323.253 189.674 273.753C220.676 318.753 254.176 314.753 285.674 290.753L265.174 321.26L265.176 321.26Z",
    fill: "#2E0C4F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M363.694 292.618L294.209 259.979L277.017 300.293L348.663 322.559L363.694 292.618Z",
    fill: "#1A132C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170.926 209.628L200.358 224.728L196.869 265.819L151.767 242.704C157.418 229.507 162.652 220.853 170.926 209.628Z",
    fill: "#1A132C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "stroke0_1254_4068",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.506 275.329C286.292 305.923 256.137 324.416 227.153 316.634C198.17 308.852 181.333 277.743 189.547 247.149C197.761 216.555 227.916 198.062 256.9 205.844C285.883 213.626 302.72 244.735 294.506 275.329Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M294.506 275.329C286.292 305.923 256.137 324.416 227.153 316.634C198.17 308.852 181.333 277.743 189.547 247.149C197.761 216.555 227.916 198.062 256.9 205.844C285.883 213.626 302.72 244.735 294.506 275.329Z",
    strokeWidth: 25.3721,
    stroke: "url(#paint2_linear_1254_4068)",
    mask: "url(#stroke0_1254_4068)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M394.572 327.164C398.336 314.149 401.64 295.086 388.675 291.605C375.71 288.124 375.217 295.713 375.217 295.713L359.012 333.061C359.012 333.061 364.454 353.055 372.044 353.548C379.633 354.041 390.953 339.676 394.572 327.164Z",
    fill: "#FAFBF6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M375.818 281.975C386.366 285.174 390.117 291.991 390.117 291.991C390.117 291.991 377.325 299.368 370.47 319.149C361.678 344.517 372.045 353.548 372.045 353.548C372.045 353.548 366.293 354.486 362.628 354.109C356.805 353.509 348.609 348.8 348.609 348.8C348.609 348.8 338.632 339.944 351.076 310.853C363.52 281.762 375.818 281.975 375.818 281.975Z",
    fill: "#252644"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M311.624 472.242C311.624 472.242 293.884 437.581 296.485 433.646C299.086 429.711 320.133 426.096 324.455 427.256C328.777 428.416 342.495 463.599 340.174 472.242C337.853 480.886 333.893 511.242 329.174 532.242C324.455 553.242 311.624 615.242 311.624 615.242L288.674 606.242L311.624 472.242Z",
    fill: "#825CCD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8296 355.664C74.5343 363.924 108.432 375.811 110.316 373.058C112.2 370.306 113.507 354.226 111.335 350.314C109.163 346.401 89.1701 347.266 89.1701 347.266L92.2139 340.458L66.1402 324.227C66.1402 324.227 55.1248 347.404 64.8296 355.664Z",
    fill: "#825CCD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M292.843 592.13C285.022 597.405 278.803 608.428 281.44 612.338C284.078 616.249 287.129 616.714 287.129 616.714C287.129 616.714 284.242 622.396 289.28 634.928C294.319 647.459 306.543 657.99 306.543 657.99C315.611 659.908 319.491 658.746 322.984 650.314C327.757 649.365 330.159 648.069 332.878 641.364C339.924 638.103 340.759 635.764 340.935 631.379C340.935 631.379 328.548 614.7 326.311 612.227C324.074 609.753 319.999 606.243 319.999 606.243C319.999 606.243 318.234 594.348 315.997 591.875C313.76 589.401 300.664 586.855 292.843 592.13Z",
    fill: "#1A132C"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_1254_4068",
    fill: "url(#paint3_radial_1254_4068)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "stroke2_1254_4068",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_1254_4068"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.129 413.275L204.584 426.301C207.804 427.391 209.561 430.855 208.54 434.097L200.831 458.559C199.778 461.9 196.185 463.723 192.867 462.599L154.411 449.574C151.192 448.483 149.435 445.019 150.456 441.777L158.165 417.316C159.217 413.974 162.811 412.151 166.129 413.275Z",
    strokeWidth: 9.37284,
    stroke: "#2D3F66",
    mask: "url(#stroke2_1254_4068)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.766 463.301L133.884 459.744C132.065 459.09 131.052 457.151 131.553 455.284C132.117 453.185 134.355 452.015 136.401 452.751L146.283 456.308C148.102 456.962 149.115 458.901 148.614 460.768C148.05 462.868 145.812 464.037 143.766 463.301Z",
    fill: "#2B3956"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 473.331L159.158 470.09C157.319 469.493 156.245 467.587 156.687 465.706C157.184 463.589 159.384 462.349 161.452 463.02L171.442 466.262C173.28 466.859 174.354 468.765 173.913 470.646C173.416 472.763 171.216 474.003 169.148 473.331Z",
    fill: "#2B3956"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198.427 481.449L188.229 478.935C186.353 478.473 185.144 476.649 185.449 474.74C185.792 472.594 187.897 471.199 190.008 471.719L200.206 474.233C202.082 474.696 203.291 476.52 202.986 478.428C202.642 480.575 200.537 481.97 198.427 481.449Z",
    fill: "#2B3956"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M380.326 323.339C381.1 320.458 388.622 303.945 392.944 305.106C397.265 306.266 393.398 320.672 392.237 324.993C391.077 329.315 385.769 343.333 380.007 341.786C374.974 340.435 378.386 329.57 379.846 324.921C380.058 324.247 380.228 323.704 380.326 323.339Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#402F51"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.247 247.501L124.543 331.893L118.887 324.197L151.747 241.501L160.247 247.501Z",
    fill: "#A1ADFF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.984 351.788L330.644 404.208L337.179 402.874L359.747 353.335L353.984 351.788Z",
    fill: "#A1ADFF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.161 470.243C329.12 454.019 325.535 444.706 316.661 427.743L324.661 427.243C333.358 443.318 337.102 452.391 340.661 468.743C333.514 518.886 327.374 545.312 316.161 592.243L311.161 589.743C322.774 535.141 328.917 505.479 333.161 470.243Z",
    fill: "#5F75FF",
    fillOpacity: 0.78,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.233 526.346C104.985 528.661 101.434 528.331 96.4063 523.593C97.1975 519.395 99.0396 517.011 104.771 512.678C107.099 514.486 109.94 515.264 117.679 516.048C117.525 520.08 116.128 522.333 112.233 526.346Z",
    fill: "#636E8A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M110.752 526.659C110.165 534.43 110.981 538.037 115.604 542.403C130.382 540.642 138.452 537.882 152.313 528.546C161.075 526.004 165.628 524.426 170.359 520.159C169.299 512.909 168.167 509.043 162.279 503.572C153.251 506.557 148.042 507.257 138.313 505.589C130.147 511.063 125.038 513.793 113.279 516.978C113.815 520.977 113.483 523.129 110.752 526.659Z",
    fill: "#333F59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M213.54 541.068C209.995 536.869 209.431 527.61 209.431 527.61C209.431 527.61 205.296 532.936 203.843 536.92C202.234 541.332 201.378 544.205 202.189 548.831C203.259 554.93 204.835 561.502 211.006 562.009C218.187 562.599 219.969 545.883 219.969 545.883C219.969 545.883 215.564 543.465 213.54 541.068Z",
    fill: "#333F59"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M232.16 552.245C227.004 550.742 218.67 551.094 219.968 545.883C220.413 544.095 221.135 543.104 222.569 541.948C226.675 538.637 229.883 546.533 235.147 546.869C238.278 547.069 240.088 545.132 243.123 545.922C246.905 546.907 249.435 548.837 250.606 552.564C252.766 559.438 239.077 554.261 232.16 552.245Z",
    fill: "#636E8A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.653 114.749C103.586 114.751 102.6 114.891 100.78 115.469C97.0218 116.662 95.8838 121.66 90.8044 140.967C86.9788 155.508 90.0211 172.006 91.5834 176.683C92.9851 180.878 96.3717 183.838 117.361 198.662C128.765 206.717 131.884 215.302 133.498 221.602C135.701 230.199 131.483 235.516 118.971 252.261C104.222 272 96.1372 277.583 93.8384 285.961C88.2013 306.505 92.6788 315.229 96.4959 325.256C100.946 336.949 109.328 347.36 115.165 354.773C118.854 360.529 121.626 368.199 124.053 378.111C125.027 382.862 125.481 387.044 124.839 392.173",
    strokeWidth: 1.4464,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8232 306.636C67.6907 309.26 63.3926 321.257 67.3293 330.456C71.2659 339.655 78.8847 342.199 78.8847 342.199C85.5374 343.645 89.2217 343.617 95.5281 338.704C99.2641 339.28 116.724 339.065 119.616 335.651C122.509 332.237 120.311 324.447 118.572 323.038C116.833 321.629 123.566 319.45 122.08 314.281C120.594 309.113 115.251 308.497 115.251 308.497C116.409 302.247 116.358 300.031 110.966 295.093C110.966 295.093 100.456 295.964 93.1848 297.624C85.914 299.284 79.9557 304.011 73.8232 306.636Z",
    fill: "#2B1C36"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M252.777 386.38L159.66 349.489C159.66 349.489 176.937 314.96 221.941 332.79C266.944 350.62 252.777 386.38 252.777 386.38Z",
    fill: "#310C54"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.256 388.966L157.66 351.489C157.66 351.489 172.398 323.514 218.117 341.627C263.835 359.74 252.256 388.966 252.256 388.966Z",
    fill: "#9573E1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252.776 386.38L159.66 349.489C159.66 349.489 175.348 318.973 220.351 336.802C265.355 354.632 252.776 386.38 252.776 386.38Z",
    fill: "#211022"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1254_4068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 331,
    width: 96,
    height: 56
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M252.777 386.38L159.661 349.489C159.661 349.489 175.349 318.973 220.352 336.802C265.356 354.632 252.777 386.38 252.777 386.38Z",
    fill: "#211022"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1254_4068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.489 345.125L179.108 358.708L193.509 364.413L190.665 354.388L184.489 345.125Z",
    fill: "url(#paint4_linear_1254_4068)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_1254_4068",
    fill: "#E2D6E0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_1254_4068",
    fill: "url(#paint5_linear_1254_4068)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_1254_4068",
    fill: "#FF8AEB"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_1254_4068",
    fill: "url(#paint6_linear_1254_4068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.402 347.625L205.781 329.136L227.382 337.694L222.6 359.046L199.402 347.625Z",
    fill: "url(#paint7_linear_1254_4068)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke5_1254_4068",
    fill: "#E2D6E0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke5_1254_4068",
    fill: "#8A7A88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.486 344.283L195.98 365.969L215.801 371.919L220.2 360.816L202.486 344.283Z",
    fill: "url(#paint8_linear_1254_4068)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.63 367.466C241.948 374.69 240.598 378.149 236.402 383.186L216.155 373.477L221.747 364.26C230.612 366.567 234.961 366.937 242.63 367.466Z",
    fill: "#CEC1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.991 376.578C254.116 379.27 252.578 383.243 249.627 385.282L240.981 381.857C240.981 381.857 244.482 373.618 246.828 371.442C249.174 369.266 253.396 370.868 253.991 376.578Z",
    fill: "#E2E2E2"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5049 36.4302L80.6998 77.0153L107.044 72.994L100.85 32.4089L74.5049 36.4302Z",
    fill: "url(#paint9_linear_1254_4068)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke6_1254_4068",
    fill: "url(#paint10_radial_1254_4068)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "stroke7_1254_4068",
    maskUnits: "userSpaceOnUse",
    x: 86.4877,
    y: 43.5495,
    width: 23.3924,
    height: 26.743,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 86.4877,
    y: 43.5495,
    width: 23.3924,
    height: 26.743
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke6_1254_4068"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.939 55.5966C107.773 61.0626 104.719 66.0629 100.119 66.7652C95.5177 67.4675 91.1116 63.6057 90.2773 58.1397C89.443 52.6737 92.4963 47.6734 97.0972 46.9711C101.698 46.2688 106.104 50.1306 106.939 55.5966Z",
    strokeWidth: 2.01674,
    stroke: "#FFE7E6",
    mask: "url(#stroke7_1254_4068)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7402 35.7767L71.3296 45.2214C71.3296 45.2214 75.0556 38.6052 88.2182 35.576C101.381 32.5468 105.226 36.2586 105.226 36.2586L112.898 22.5556C112.898 22.5556 107.713 13.3052 102.273 9.75091C85.6917 -1.08346 58.7402 35.7767 58.7402 35.7767Z",
    fill: "#5C6FAE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1711 47.6775C82.2101 45.7373 78.9929 44.4593 71.3187 45.1496C84.0177 29.9668 91.488 28.0124 105.369 36.2364L114.231 43.6998C105.183 40.5066 99.3976 41.7051 88.1711 47.6775Z",
    fill: "#271310"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke8_1254_4068",
    fill: "#252525"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke8_1254_4068",
    fill: "url(#paint11_linear_1254_4068)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1254_4068",
    x: 9.61133,
    y: 7.75732,
    width: 450.214,
    height: 665.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 14
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1254_4068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1254_4068",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1254_4068",
    x1: 207.054,
    y1: 372.58,
    x2: 176.347,
    y2: 486.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2AFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63537D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1254_4068",
    x1: 260.149,
    y1: 280.071,
    x2: 224.761,
    y2: 270.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#539B18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1254_4068",
    x1: 256.9,
    y1: 205.844,
    x2: 227.153,
    y2: 316.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#3A3652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A98DBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1254_4068",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.498 437.937) rotate(104.698) scale(20.9098 27.4151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1254_4068",
    x1: 191.69,
    y1: 347.978,
    x2: 186.308,
    y2: 361.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#AF98C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A890C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1254_4068",
    x1: 188.724,
    y1: 324.515,
    x2: 187.678,
    y2: 344.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4B61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1254_4068",
    x1: 174.253,
    y1: 342.818,
    x2: 169.535,
    y2: 354.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#AF98C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A890C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1254_4068",
    x1: 218.17,
    y1: 334.045,
    x2: 210.21,
    y2: 354.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#97819E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1254_4068",
    x1: 213.206,
    y1: 355.809,
    x2: 204.663,
    y2: 369.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A890C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1254_4068",
    x1: 103.947,
    y1: 52.7015,
    x2: 77.6023,
    y2: 56.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111187,
    stopColor: "#555D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27176,
    stopColor: "#E5E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568013,
    stopColor: "#6A6B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80591,
    stopColor: "#56596A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1254_4068",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.6079 56.8682) rotate(81.3214) scale(10.0117 8.42711)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E35A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D0406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1254_4068",
    x1: 185.043,
    y1: 84.5902,
    x2: 9.62562,
    y2: 84.3579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274038,
    stopColor: "#555D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427885,
    stopColor: "#E5E8F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568013,
    stopColor: "#6A6B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723797,
    stopColor: "#56596A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313749"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stroke1_1254_4068",
    d: "M204.584 426.301L166.129 413.275C162.811 412.151 159.217 413.974 158.165 417.316L150.456 441.777C149.435 445.019 151.192 448.483 154.411 449.574L192.867 462.599C196.185 463.723 199.778 461.9 200.831 458.559L208.54 434.097C209.561 430.855 207.804 427.391 204.584 426.301Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke3_1254_4068",
    d: "M181.068 338.468C180.347 334.302 186.449 324.885 186.449 324.885L202.969 331.43C202.969 331.43 198.846 345.512 193.822 345.945C188.797 346.379 181.788 342.634 181.068 338.468Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke4_1254_4068",
    d: "M168.071 342.597C163.569 345.357 162.479 351.931 162.479 351.931L176.88 357.637C176.88 357.637 178.638 350.155 176.093 346.722C173.995 343.892 172.573 339.836 168.071 342.597Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke5_1254_4068",
    d: "M227.783 349.591L230.324 340.31L248.788 345.796L237.34 363.223C231.187 359.801 227.789 357.841 227.783 349.591Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke6_1254_4068",
    d: "M106.939 55.5966C107.773 61.0626 104.719 66.0629 100.119 66.7652C95.5177 67.4675 91.1116 63.6057 90.2773 58.1397C89.443 52.6737 92.4963 47.6734 97.0972 46.9711C101.698 46.2688 106.104 50.1306 106.939 55.5966Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke8_1254_4068",
    d: "M30.0476 39.8849C10.2444 72.2706 4.38713 90.5865 14.4363 123.864C14.4363 123.864 34.4804 90.3908 43.4661 101.403C52.4518 112.415 46.935 124.907 46.935 124.907C46.935 124.907 61.9592 106.427 70.4548 109.938C78.9504 113.45 72.923 133.942 72.923 133.942C72.923 133.942 87.4486 114.461 94.9396 121.471C102.431 128.481 103.909 144.483 103.909 144.483C103.909 144.483 102.435 124.981 106.943 118.987C111.451 112.993 133.935 125.023 133.935 125.023C133.935 125.023 124.963 103.511 132.471 98.0206C139.978 92.5305 156.457 108.552 156.457 108.552C156.457 108.552 147.978 92.0411 161.485 87.059C174.992 82.0768 184.966 101.59 184.966 101.59C185.567 70.0541 182.461 52.7006 147.568 24.5405C143.466 46.773 137.474 57.5271 115.506 71.4981L74.4972 77.9438C55.0142 79.4266 45.6869 68.0306 30.0476 39.8849Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvilMinion);
export default __webpack_public_path__ + "static/media/evilMinion.13358db0c22cc5da9e890232e53be84c.svg";
export { ForwardRef as ReactComponent };